import { useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useZugnummerStore } from '@/store/useZugnummerStore'
import { useBfnStore } from '@/store/useBfnStore'
import { isRelevant } from '../utils/archive-entry-classification'

export default function useBfnZugnummerLogin() {
  const zugnummer = useZugnummerStore(useShallow((state) => state.zugnummer))
  const data = useBfnStore(useShallow((state) => state.data))
  const [committedZugnummer, setCommittedZugnummer] = useState(zugnummer)
  const [pendingZugnummer, setPendingZugnummer] = useState<string | null>(null)

  if (committedZugnummer !== zugnummer && pendingZugnummer === null) {
    const hasRelevantForPrev =
      committedZugnummer !== '' &&
      Object.values(data).some((entry) => isRelevant(entry, committedZugnummer))

    if (hasRelevantForPrev) {
      setPendingZugnummer(committedZugnummer)
    }
    setCommittedZugnummer(zugnummer)
  }
  const effectiveZugnummer = pendingZugnummer ?? zugnummer
  const showArchivHinweis = pendingZugnummer !== null

  const dismissArchivHinweis = () => setPendingZugnummer(null)

  return {
    showArchivHinweis,
    dismissArchivHinweis,
    effectiveZugnummer
  }
}
